export default "__VITE_ASSET__cce5bb77__"